$(function(){
	
	$('.load').removeClass('load');
	
	var ua = navigator.userAgent.toLowerCase();
	  var isMobile = /iphone|ipod|android.*mobile|windows.*phone|blackberry/.test(ua);
	  var isTablet = /ipad|android(?!.*mobile)|windows.*touch/.test(ua);
	
	  if (isMobile || isTablet) {
		console.log('sp tablet');
		$('.ub-chart__pin').click(function(){
			var target = $(this).find('.ub-chart__products');
			$('.ub-chart__pin').removeClass('active');
			$(this).add(target).addClass('active');
		});
		
		$('.ub-chart__products-close').click(function(){
			$('.ub-chart__pin,.ub-chart__products').removeClass('active');
			return false;
		});
		
		$('.ub-carta__item').click(function(){
			$('.ub-carta__item').removeClass('active')
			$(this).addClass('active');
		});
	  }
	
	$('.ub-products').on('init', function (event, slick, currentSlide, nextSlide) {
		slideItem=$(".slick-slide")
		for(let i=0; i < slick.slideCount; i++){
			let slideImg = slideItem.filter(function(){return($(this).data('slick-index') === i)}).find("img").clone()
			let slideText = slideItem.filter(function(){return($(this).data('slick-index') === i)}).find(".ub-products__title a").text()
			let dot = $(".slick-dots").find("li").eq(i).find("button")
			let src = slideImg.attr('src')
			dot.css("background-image",`url(${src})`);
			$(".slick-dots").find("li").eq(i).append(slideText);
		}
	})
	
	$('.ub-products').slick({
		dots: true,
		arrows: true,
		infinite: true,
		autoplay: true,
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 4000,
		slidesToShow: 1,
		slidesToScroll: 1,
		centerMode: true,
		centerPadding: '16%',
		slide: '.ub-products__item',
		pauseOnFocus: false,
		pauseOnHover: false,
		pauseOnDotsHover: false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					centerPadding: '16px',
				}
			}
		]
	});
	
	gsap.fromTo(
		'.ub-list__item .budge', {
			scale: 2,
			opacity: 0,
		}, {
			scale: 1,
			opacity: 1,
			duration: 0.6,
			ease: "power2.out",
			scrollTrigger: {
				trigger: '.ub-list__item',
				start: 'top 80%',
				toggleActions: 'play none none reverse'
			}
		}
	);
	
	
	gsap.utils.toArray('.ub-chart__pin').forEach((el) => {
	  gsap.fromTo(
		el, 
		{ scale: 0, opacity: 0 }, 
		{ 
		  scale: 1, opacity: 1, duration: 0.3, ease: "power2.out",
		  scrollTrigger: {
			trigger: el,
			start: 'top 80%',
			toggleActions: 'play none none reverse'
		  }
		}
	  );
	});
	
	gsap.utils.toArray('.ub-carta__item').forEach((el,index) => {
	  gsap.fromTo(
		el, 
		{ y: 100, opacity: 0 }, 
		{ 
		  y: 0, opacity: 1, duration: 0.3, ease: "power2.out",
		  delay: index * 0.2,
		  scrollTrigger: {
			trigger: '.ub-carta',
			start: 'top 80%',
			toggleActions: 'play none none reverse'
		  }
		}
	  );
	});
	
	gsap.fromTo(
		'.ub-shop-list__header-image', {
			y: 30,
			opacity: 0,
		}, {
			y: 0,
			opacity: 1,
			duration: 0.6,
			ease: "power2.out",
			scrollTrigger: {
				trigger: '.ub-shop-list',
				start: 'top 80%',
				toggleActions: 'play none none reverse'
			}
		}
	);
	
});